/** Customer-facing contact details. */
export const CONTACT_EMAIL = 'iclony@gmail.com';
export const CONTACT_PHONE_TEL = '+40736917034';
export const CONTACT_PHONE_DISPLAY = '+40 736 917 034';
export const CONTACT_FACEBOOK_URL = 'https://www.facebook.com/deeznuts.ro';
export const CONTACT_WHATSAPP_URL = 'https://wa.me/40736917034';
